import { routes } from '@/app/routing/router'
import { DevToolsView } from './view'

const currentRoute = routes.devTools

const DevToolsRoute = {
  view: DevToolsView,
  route: currentRoute,
}

export { currentRoute, DevToolsRoute }
